/*
 * Service copy arrives from i18n as plain text: a blank line separates blocks,
 * a single newline separates lines within a block, and a "•" or "-" prefix
 * marks a bullet.
 *
 * Both service renderers parse that same shape, so the rules live here rather
 * than in either of them. When only renderFormattedText knew about bullets,
 * renderProcessSteps rendered carrier screening's step 5 as five paragraphs
 * each opening with a stray "•".
 */

const BULLET_PREFIX = /^\s*[•-]\s*/;

export const isBulletLine = (line) => BULLET_PREFIX.test(line);

export const stripBullet = (line) => line.replace(BULLET_PREFIX, "").trim();

// Bullets are collected out of the block and rendered as one list beneath its
// prose. In every locale the copy already orders them that way — an
// introducing line, then its bullets — so nothing is resequenced in practice.
export const splitBullets = (lines) => ({
  prose: lines.filter((line) => !isBulletLine(line)),
  bullets: lines.filter(isBulletLine).map(stripBullet),
});

export const toBlocks = (text) =>
  text
    .split("\n\n")
    .map((block) => block.split("\n").filter((line) => line.trim() !== ""))
    .filter((lines) => lines.length > 0);
